import { render, staticRenderFns } from "./MakeupLessons.vue?vue&type=template&id=0f3f7a7d&"
import script from "./MakeupLessons.vue?vue&type=script&lang=js&"
export * from "./MakeupLessons.vue?vue&type=script&lang=js&"
import style0 from "./MakeupLessons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports